<div class="modal-box add-call-note-modal" cdkDrag>
    <form class="add-call-note-modal__form modal-form" [formGroup]="addClientCallForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-call-note-modal__header" cdkDragHandle>
            <div class="add-call-note-modal__headline modal-headline">
                <span class="add-call-note-modal__eyebrow modal-eyebrow">{{ 'CALL_WITH_CLIENT' | translate }}</span>
                <h4 class="modal-title add-call-note-modal__title modal-heading">
                    <a class="add-call-note-modal__client-link" href="/pages/client-details/{{iClientId}}" target="_blank">{{clientData.fullName}}</a>
                </h4>
            </div>
            <button type="button" class="add-call-note-modal__close modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-call-note-modal__body">
            <div class="add-call-note-modal__workspace" fxLayout="column" fxLayoutGap="16px">
                <div class="tier-banner tier-banner--compact add-call-note-modal__tier-banner" *ngIf="isTiered" [ngClass]="tierBannerClass" role="status">
                    <h5 class="tier-banner__title">{{ tierName | P_TierName }}</h5>
                </div>
                <div class="add-call-note-modal__panel add-call-note-modal__panel--call" fxLayout="column" fxLayoutGap="16px">
                    <div class="add-call-note-modal__field-grid" fxLayout="row" fxLayoutGap="16px">
                        <div class="add-call-note-modal__field modal-field" fxFlex>
                            <label class="modal-label" for="callNotes">{{ 'CALL_NOTES' | translate }}</label>
                            <textarea id="callNotes" rows="5" class="form-control add-call-note-modal__control add-call-note-modal__control--textarea modal-control modal-control--textarea" formControlName="callNotes"
                                [ngClass]="{ 'is-invalid': submitted && f.callNotes.errors }"></textarea>
                            <div *ngIf="submitted && f.callNotes.errors" class="invalid-feedback add-call-note-modal__feedback modal-feedback">
                                <div *ngIf="f.callNotes.errors.required">{{ 'CALL_NOTES_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                        <div class="add-call-note-modal__field modal-field" fxFlex>
                            <label class="modal-label" for="nextAction">{{ 'NEXT_ACTION' | translate }}</label>
                            <textarea id="nextAction" rows="5" class="form-control add-call-note-modal__control add-call-note-modal__control--textarea modal-control modal-control--textarea" formControlName="nextAction"
                                [ngClass]="{ 'is-invalid': submitted && f.nextAction.errors }"></textarea>
                            <div *ngIf="submitted && f.nextAction.errors" class="invalid-feedback add-call-note-modal__feedback modal-feedback">
                                <div *ngIf="f.nextAction.errors.required">{{ 'NEXT_ACTION_IS_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="add-call-note-modal__actions-row" fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="16px">
                        <div class="add-call-note-modal__next-call-grid" fxFlex="60" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
                            <div class="add-call-note-modal__field modal-field" fxFlex>
                                <label class="modal-label" for="addTaskDate">{{ 'SELECT_THE_NEXT_CALL_DATE' | translate }}</label>
                                <input id="addTaskDate"
                                    class="form-control add-call-note-modal__control modal-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.addTaskDate.errors }"
                                    mwlFlatpickr
                                    [altInputClass]="'datetime add-call-note-modal__control add-call-note-modal__control--date'"
                                    [altInput]="true"
                                    [convertModelValue]="true"
                                    formControlName="addTaskDate" />
                                <div *ngIf="submitted && f.addTaskDate.errors" class="invalid-feedback add-call-note-modal__feedback modal-feedback">
                                    <div *ngIf="f.addTaskDate.errors.required">{{ 'REQUIRED' | translate }}</div>
                                </div>
                            </div>
                            <div class="add-call-note-modal__field modal-field" fxFlex>
                                <label class="modal-label" for="nextTaskAssignedUserId">{{ 'ASSIGN_NEXT_CALL_TO' | translate }}</label>
                                <ng-select id="nextTaskAssignedUserId"
                                    class="modal-select"
                                    [placeholder]="'DEFAULT_CLIENT_DMS' | translate"
                                    [items]="allUsers"
                                    bindLabel="fullName"
                                    bindValue="id"
                                    formControlName="nextTaskAssignedUserId">
                                </ng-select>
                                <div *ngIf="submitted && f.nextTaskAssignedUserId.errors" class="invalid-feedback add-call-note-modal__feedback modal-feedback">
                                    <div *ngIf="f.nextTaskAssignedUserId.errors.required">{{ 'REQUIRED' | translate }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="add-call-note-modal__cta-group" fxFlex="40" fxLayout="row" fxLayoutAlign="space-between end">
                            <label class="add-call-note-modal__checkbox">
                                <input type="checkbox" formControlName="sendMissedCallEmail" />
                                <span>{{ 'SEND_MISSED_CALL_EMAIL' | translate }}</span>
                            </label>
                            <button type="submit" class="blue-button add-call-note-modal__button modal-button">{{ 'COMPLETE_TASK' | translate }}</button>
                        </div>
                    </div>
                </div>

                <div class="add-call-note-modal__lower" fxLayout="row-reverse" fxLayoutAlign="space-between start" fxLayoutGap="16px">
                    <div fxFlex class="add-call-note-modal__panel add-call-note-modal__panel--notes notesSection">
                        <div class="notes-tabs add-call-note-modal__tabs">
                            <button type="button"
                                class="notes-tab add-call-note-modal__tab"
                                [class.active]="activeNotesSection === 'client'"
                                (click)="setActiveNotesSection('client')">
                                {{ 'CLIENT_NOTES' | translate }}
                            </button>
                            <button type="button"
                                class="notes-tab add-call-note-modal__tab"
                                [class.active]="activeNotesSection === 'campaign'"
                                (click)="setActiveNotesSection('campaign')">
                                {{ 'CAMPAIGN_NOTES' | translate }}
                            </button>
                            <button type="button"
                                class="notes-tab add-call-note-modal__tab"
                                [class.active]="activeNotesSection === 'tasks'"
                                (click)="setActiveNotesSection('tasks')">
                                {{ 'UPCOMING_TASKS' | translate }}
                            </button>
                        </div>

                        <div class="notes-panel add-call-note-modal__notes-panel" *ngIf="activeNotesSection === 'client'">
                            <ul class="notes-list" *ngIf="clientNotes.length > 0; else noClientNotes">
                                <li *ngFor="let note of clientNotes">
                                    <strong>{{ note.title }}</strong>
                                    <br />
                                    <small>{{ note.updatedOn | date:'mediumDate' }}</small>
                                    <small> - {{ note.assignedUserName }}</small>
                                    <p>{{ note.description }}</p>
                                </li>
                            </ul>
                            <ng-template #noClientNotes><p class="notes-empty">{{ 'NO_CLIENT_NOTES_AVAILABLE' | translate }}</p></ng-template>
                        </div>

                        <div class="notes-panel add-call-note-modal__notes-panel" *ngIf="activeNotesSection === 'campaign'">
                            <ul class="notes-list" *ngIf="campaignNotes.length > 0; else noCampaignNotes">
                                <li *ngFor="let note of campaignNotes">
                                    <strong>{{ note.title }} ({{ note.campaignName }})</strong>
                                    <br />
                                    <small>{{ note.updatedOn | date:'mediumDate' }}</small>
                                    <small> - {{ note.assignedUserName }}</small>
                                    <p>{{ note.description }}</p>
                                </li>
                            </ul>
                            <ng-template #noCampaignNotes><p class="notes-empty">{{ 'NO_CAMPAIGN_NOTES_AVAILABLE' | translate }}</p></ng-template>
                        </div>

                        <div class="notes-panel add-call-note-modal__notes-panel" *ngIf="activeNotesSection === 'tasks'">
                            <ul class="notes-list" *ngIf="tasksDataNotCompleted.length > 0; else noTasks">
                                <li *ngFor="let task of tasksDataNotCompleted">
                                    <strong>{{ task.title }} - {{ task.assignedUserName }}</strong>
                                    <br />
                                    <small>Due: {{ task.dueDate | date:'mediumDate' }}</small>
                                    <p>{{ task.description }}</p>
                                </li>
                            </ul>
                            <ng-template #noTasks><p class="notes-empty">{{ 'NO_UPCOMING_TASKS_AVAILABLE' | translate }}</p></ng-template>
                        </div>
                    </div>

                    <div class="add-call-note-modal__panel add-call-note-modal__panel--update updateTask" fxLayout="column" fxLayoutGap="16px" *ngIf="iTask">
                        <h5>{{ 'UPDATE_EXISTING_CALL_TASK' | translate }}</h5>
                        <div class="add-call-note-modal__field modal-field">
                            <label class="modal-label" for="dueDate">{{ 'DUE_DATE' | translate }}</label>
                            <input id="dueDate" mwlFlatpickr
                                [altInputClass]="'datetime add-call-note-modal__control add-call-note-modal__control--date'"
                                [altInput]="true"
                                [convertModelValue]="true"
                                formControlName="dueDate"
                                class="form-control add-call-note-modal__control modal-control" />
                        </div>
                        <div class="add-call-note-modal__field modal-field">
                            <label class="modal-label" for="assignedUserId">{{ 'ASSIGNED_USER' | translate }}</label>
                            <ng-select id="assignedUserId" class="modal-select" [placeholder]="'NONE' | translate" [items]="allUsers" bindLabel="fullName" bindValue="id" formControlName="assignedUserId">
                            </ng-select>
                        </div>
                        <div class="add-call-note-modal__update-actions">
                            <button
                                type="button"
                                class="gray-button add-call-note-modal__button add-call-note-modal__button--secondary modal-button"
                                [disabled]="taskUpdateSaving"
                                (click)="updateTriggerTask()">
                                {{ taskUpdateSaving ? ('UPDATING_DOTS' | translate) : ('UPDATE_TASK' | translate) }}
                            </button>
                            <small *ngIf="taskUpdateError" class="text-danger add-call-note-modal__update-error">{{ taskUpdateError }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer add-call-note-modal__footer" cdkDragHandle>
            <button type="button" class="red-outline-button add-call-note-modal__button add-call-note-modal__button--cancel modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
        </div>
    </form>
</div>
